<template>
  <div>
    <v-stepper v-model="e1" >
      <v-stepper-header>
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
          editable
          style="color:red"
        >
          {{ $t("_editer_les_valeurs_pvsyst_") }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          :complete="e1 > 2"
          step="2"
          :editable ="e1 >= 2"
        >
          {{ $t("_afficher_les_resultats_")}}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="12">
              <pvsyst-input ref="pvsyst_input"/>
            </v-col>
            <v-col></v-col>
          </v-row>

          <v-row >
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn
                @click="resetValues()"
              >
                {{ $t("_reinitialiser_les_valeurs_") }}
              </v-btn>
            <!-- </v-col>
            <v-col cols="6"> -->
              <v-btn
                @click="runCalculate()"
              >
                {{ $t("_valider_les_valeurs_") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row>
            <v-col cols="12">
              <data-comparaison ref="data_comparaison" :res="data"></data-comparaison>
            </v-col>
            <v-col></v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <v-btn
                @click="e1 = 1"
              >
                {{ $t("_editer_les_valeurs_pvsyst_") }}
              </v-btn>
            </v-col>

            <v-col cols="4">
              <v-btn
                style="margin-right:20px"
                @click="downloadPvsyst()">
                {{ $t("_telecharger_les_donnees_pvsyst_") }}
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn
                @click="downloadResult()">
                {{ $t("_telecharger_le_tableau_comparatif_") }}
              </v-btn>
            </v-col>
          </v-row>

        </v-stepper-content>
      </v-stepper-items>

    </v-stepper>
  </div>
  
</template>
<script>
import DataComparaison from './DataComparaison.vue'
import PvsystInput from './PvsystInput.vue'
import api from "@/api/api"


  export default {
  components: { PvsystInput, DataComparaison},
    methods: {
      async runCalculate(){
        /**
         * Run calculate and switch the stepper to the other step
         */
        this.data = await this.$refs.pvsyst_input.runCalculate()
        if(this.data.execute){
          this.e1 = 2
          this.$refs.data_comparaison.on_mounted()
        }
      },

      async recalculate(){
        /**
         * run calculate without change stepper step
         */
        this.data = await this.$refs.pvsyst_input.runCalculate()
        if(this.data.execute){
          this.$refs.data_comparaison.on_mounted()
        }
      },

      resetValues(){
        /**
         * reset values
         */
        this.$refs.pvsyst_input.resetValues()
        this.$forceUpdate();
      },

      downloadPvsyst(){
        //console.log( this.$root.$i18n.locale)
        api.downloadPvsystData({"input":this.$store.getters.inputData}, "input_values", this.$root.$i18n.locale)
        .then((res)=>{
          let name = "pvsyst_values"+ this.$route.params.id + ".xlsx"
          let a = document.createElement('a');
          a.href = URL.createObjectURL(res.data) ;
          a.download = name;
          a.click();}
        )
      },

      downloadResult(){
        /**
         * Download data in xlsx format
         */
        api.downloadPvsystData({"input":this.$refs.data_comparaison.my_data}, "pvsyst_result", this.$root.$i18n.locale)
        .then((res)=>{
          let name = "tableau_comparatif_"+ this.$route.params.id + "_" + this.$store.getters.expertDates.start + "__" 
            + this.$store.getters.expertDates.end  + ".xlsx"
          let a = document.createElement('a');
          a.href = URL.createObjectURL(res.data);
          a.download = name;
          a.click();}
        )

        
      }
    },
    data: () => ({
      tab: null,
      items: [
          '_donnees_entree_', '_resultat_'
        ],
      e1:1,
      data: null
      //pvsyst_input: null
    }),
  }

</script>

<style scoped>



</style>
